import React from "react"
import {useParams, Navigate, NavLink, useNavigate} from "react-router-dom"
import { alphabeticalSort } from "../../../utils/stringUtils"
import { countCartItems, getCartTotal } from "../../../utils/cartUtils"

import { usePayeeStore } from "../../../contexts/PayeeStoreContext"
import { PAYEE_CATALOG_TYPE_ORDERING } from "../../../constants/payeeCatalog"

import Icon from "../../../components/Icon"
import ProductList from "../../../containers/ProductList"
import PlaceOrderButton from "../../../containers/PlaceOrderButton"

import {connect} from "react-redux"

const Cart = ({carts, payeeProducts, payeeCatalogs}) => {
    const params = useParams()
    const {payeeId="", cartId="", payeeCatalogId=""} = usePayeeStore()
    const {catalogHandleId, payeeHandleId} = params
    const cart = carts.cartsById[cartId]
    const {lineItemsById={}} = cart || {}
    //payee catalogs
    const payeeCatalog = payeeCatalogs.payeeCatalogsById[payeeCatalogId]
    const {catalogType=""} = payeeCatalog || {}
    /* more complex checkout flows will involve going to the checkout page
       but most flows just use the checkout popup modal in PlaceOrderButton directly 
    */
    const goToCheckoutPage = Boolean(
        catalogType && 
        [PAYEE_CATALOG_TYPE_ORDERING].includes(catalogType)
    )
    const navigate = useNavigate();
    const handleClickGoToCheckout = () => navigate(`/${payeeHandleId}/c/${catalogHandleId}/checkout`);
    
    //if there is no cart, go back to the catalog
    if (!cart) return <Navigate replace to={`/${payeeHandleId}/c/${catalogHandleId}`} />
    const cartTotalXcd = getCartTotal(cart)
    const productListInCart = Object.values(lineItemsById)
                                 .map(item => {
                                     const productInCart = payeeProducts.payeeProductsById[item.payeeProductId]
                                     return ({
                                        ...productInCart,
                                        itemId: item.id
                                     })
                                  })
                                 .filter(product => Boolean(product && product.name))
                                 .sort((pA, pB)=> alphabeticalSort(pA.name, pB.name))
    return (
        <div>
            <div className="h2 padding-1em text-align-center">Your cart</div>
            <div className="columnLayout">
                <div className="padding-1em display-flex justify-content-space-between">
                    <div>
                        <div className="margin-bottom-1em cursor-pointer hover-background-light-grey border-radius-8px padding-5px">
                            <NavLink 
                                className="display-flex align-items-center text-decoration-none color-black" 
                                to={`/${payeeHandleId}/c/${catalogHandleId}`}
                            >
                                <Icon icon="arrow-back"/> <span className="font-size-14px">Back to item list</span>
                            </NavLink>
                        </div>
                        <div className="font-weight-600">{countCartItems(cart)} items</div>
                    </div>
                    <button className="button outline">
                        <NavLink to={`/${payeeHandleId}/c/${catalogHandleId}`}>
                            Add more
                        </NavLink> 
                    </button>
                </div>
                <ProductList 
                    productList={productListInCart} 
                    getDefaultActiveVariantId={p => p.itemId}
                    activeVariantEditable={false} //disallow changes to the selected variant from the cart page
                    payeeCatalogId={payeeCatalogId}
                    payeeId={payeeId}
                />
                <div className="spacer"></div>
            </div>
            {
                cart ? 
                <div className="fixed-bottom-bar">
                    <div className="columnLayout">
                        <div className="display-flex justify-content-space-between font-weight-600">
                            <div>Subtotal</div>
                            <div className="amount">EC ${Number(cartTotalXcd).toFixed(2)}</div>
                        </div>
                        <div className="margin-top-05em margin-bottom-05em font-size-11px text-align-justify">By continuing, you agree to share your name, billing information and item list with the merchant. You also agree to receive order updates via phone, sms and email. You agree to our Refund Policy and our Privacy Policy.</div>
                        {
                            goToCheckoutPage ?
                            <button 
                                className="button success"
                                //if the buyer has not met or passed the minimum spend, then remind them of the min spend
                                //otherwise, create the order
                                onClick={handleClickGoToCheckout} 
                            >
                                Go To Checkout
                            </button>
                            :
                            <PlaceOrderButton 
                                cartId={cartId}
                                payeeId={payeeId}
                                payeeCatalogId={payeeCatalogId}
                                payeeHandleId={payeeHandleId}
                            />
                        }
                    </div>
                </div>
                :
                null
            }
            
        </div>
    )
}

const mapStateToProps = state => ({
    carts: state.carts,
    payeeProducts: state.payeeProducts,
    payeeCatalogs: state.payeeCatalogs,
})

export default connect(mapStateToProps)(Cart)